"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceFromIv = void 0;
const __1 = require("../..");
const get_value_from_iv_1 = require("./get-value-from-iv");
/**
 * Get the device from "{@link https://healthcareinc.atlassian.net/wiki/spaces/REPORTING/pages/107675730/IV+Parameter+structure|IV Parameter}".
 *
 * @param {string} iv - A valid iv parameter string.
 *
 * @returns {string} The device value.
 *
 */
function getDeviceFromIv(iv) {
    const ivDevice = (0, get_value_from_iv_1.getValueFromIv)(iv, 'd').toLowerCase();
    const deviceMap = {
        m: __1.DeviceName.Mobile,
        p: __1.DeviceName.Mobile,
        t: __1.DeviceName.Tablet,
        c: __1.DeviceName.Desktop,
        tablet: __1.DeviceName.Tablet,
        mobile: __1.DeviceName.Mobile,
        computer: __1.DeviceName.Desktop,
        desktop: __1.DeviceName.Desktop,
    };
    return deviceMap[ivDevice] ? deviceMap[ivDevice] : '';
}
exports.getDeviceFromIv = getDeviceFromIv;
//# sourceMappingURL=get-device-from-iv.js.map